import {EnvironmentProviders, Provider} from '@angular/core';
import {createFeature, FeatureConfig, provideState} from '@ngrx/store';
import {partnerClientFeatureName, partnerClientReducer, PartnerClientState} from './store/partner-client.reducers';
import {provideEffects} from '@ngrx/effects';
import {PartnerClientEffects} from './store/partner-client.effects';
import {PartnerClientFacade} from './store/partner-client.facade';
import {PartnerClientRepository} from './store/partner-client.repository';
import {PartnerClientRestService} from './api/partner-client-rest.service';

export function providePartnerClient(): (EnvironmentProviders | Provider)[] {
    return [
        provideState(createFeature({
            name: partnerClientFeatureName,
            reducer: partnerClientReducer
        } as FeatureConfig<string, PartnerClientState>)),
        provideEffects([PartnerClientEffects]),
        PartnerClientFacade, PartnerClientRepository, PartnerClientRestService
    ];

}

